var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135183_234921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.06 56.6562H98.5391V68.4643H122.06V56.6562Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.912 13.4223C139.085 13.4223 141.658 10.8522 141.658 7.68184C141.658 4.51149 139.085 1.94141 135.912 1.94141C132.739 1.94141 130.167 4.51149 130.167 7.68184C130.167 10.8522 132.739 13.4223 135.912 13.4223Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M86.0382 139.624C136.061 139.624 176.613 134.712 176.613 128.654C176.613 122.595 136.061 117.684 86.0382 117.684C36.0154 117.684 -4.53613 122.595 -4.53613 128.654C-4.53613 134.712 36.0154 139.624 86.0382 139.624Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.526 126.566C104.526 126.566 104.136 128.61 102.412 129.034C100.689 129.459 100.499 131.239 102.142 131.434C103.785 131.629 107.514 128.971 107.514 128.971L106.865 125.797L104.526 126.566Z",
    fill: "#0D9F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.292 126.566C119.292 126.566 118.907 128.61 117.178 129.034C115.448 129.459 115.27 131.239 116.908 131.434C118.545 131.629 122.285 128.971 122.285 128.971L121.659 125.797L119.292 126.566Z",
    fill: "#0D9F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.986 71.9844H21.1221V124.538H140.986V71.9844Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.986 68.4648H21.1221V76.7081H140.986V68.4648Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.787 99.3262H129.708V126.679H134.787V99.3262Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M134.787 99.3262H129.708V126.679H134.787V99.3262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2121 76.709H21.1221V124.544H27.2121V76.709Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M52.6289 76.709H27.2061V124.544H52.6289V76.709Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.882 76.709H134.792V124.544H140.882V76.709Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M110.093 68.489L101.004 68.4316L90.2254 85.1363C87.4299 89.4779 85.8025 94.4666 85.5006 99.6202C85.1986 104.774 86.2323 109.918 88.5018 114.556L93.3968 124.567H140.899L141.008 103.201L141.387 70.7393L110.093 68.489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9409 53.9941L42.6719 68.4084H61.1142L60.3559 66.4681H53.203L54.4267 54.505L45.9409 53.9941Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8986 25.7285H26.3213V56.658H71.8986V25.7285Z",
    fill: "#0D9F3F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M41.3053 30.3086H31.3027V42.7022H41.3053V30.3086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M66.9169 30.3086H44.0449V42.7022H66.9169V30.3086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M66.912 45.252H31.3027V52.0716H66.912V45.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8986 53.9941H26.3213V59.8494H71.8986V53.9941Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8023 58.4083C51.7383 58.4083 52.4971 57.6502 52.4971 56.7149C52.4971 55.7797 51.7383 55.0215 50.8023 55.0215C49.8662 55.0215 49.1074 55.7797 49.1074 56.7149C49.1074 57.6502 49.8662 58.4083 50.8023 58.4083Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9456 80.418H29.8945V90.3202H49.9456V80.418Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9456 95.8867H29.8945V105.789H49.9456V95.8867Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.547 87.0759C40.3847 87.0759 41.0638 86.3974 41.0638 85.5604C41.0638 84.7234 40.3847 84.0449 39.547 84.0449C38.7093 84.0449 38.0303 84.7234 38.0303 85.5604C38.0303 86.3974 38.7093 87.0759 39.547 87.0759Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.547 102.351C40.3847 102.351 41.0638 101.673 41.0638 100.836C41.0638 99.9988 40.3847 99.3203 39.547 99.3203C38.7093 99.3203 38.0303 99.9988 38.0303 100.836C38.0303 101.673 38.7093 102.351 39.547 102.351Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.889 84.0457C120.889 84.0457 115.27 46.8075 128.357 40.4184C141.445 34.0293 162.582 39.9305 152.953 85.986L152.476 91.1065C152.162 94.4055 150.627 97.4688 148.173 99.698C145.719 101.927 142.521 103.162 139.205 103.161H112.627C107.749 103.161 106.261 96.491 110.702 94.4819C112.228 93.8005 113.823 93.2848 115.459 92.9434C116.812 92.6522 118.037 91.9394 118.958 90.9077C119.879 89.876 120.448 88.5788 120.584 87.203L120.889 84.0457Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11 79.0684L99.6483 91.8006C97.1447 94.3584 95.4786 97.6163 94.8712 101.142C94.2637 104.668 94.7436 108.295 96.2471 111.542L103.274 126.68L106.887 125.796L103.411 112.202C102.724 109.511 102.929 106.669 103.996 104.104C105.063 101.538 106.934 99.3887 109.329 97.9774L123.583 89.5791L112.11 79.0684Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11 79.0684L141.365 80.7905C141.365 80.7905 141.319 91.1577 137.832 93.4998C135.901 94.8029 128.731 97.3804 122.727 99.4182C120.366 100.216 118.417 101.916 117.307 104.147C116.197 106.377 116.016 108.955 116.804 111.318L121.659 125.795L117.562 126.88L108.72 109.544C107.459 107.07 107.075 104.242 107.631 101.521C108.188 98.8006 109.651 96.3492 111.783 94.5675L120.607 87.1911L112.11 79.0684Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1594 111.094H31.0557V124.538H48.1594V111.094Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.707 122.316H134.792L142.984 131.444H122.284L129.707 122.316Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M129.707 122.316H134.792L142.984 131.444H122.284L129.707 122.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.064 77.5298C144.064 77.5298 148.155 87.7018 138.94 93.5112C129.724 99.3205 119.107 97.6845 117.964 104.504C117.964 104.504 93.9138 94.9118 93.8334 94.8085C93.7529 94.7052 106.691 77.4609 117.464 75.9512L144.989 77.5298",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.751 24.4199C120.751 24.4199 120.372 24.5979 119.711 24.9251C114.937 27.2959 92.8922 36.5437 93.8976 45.2634C95.0466 55.1944 122.555 50.0108 122.555 50.0108L127.456 32.9847C127.456 32.9847 109.318 39.988 108.789 38.7251L122.578 27.514",
    fill: "#0D9F3F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M120.751 24.4199C120.751 24.4199 120.372 24.5979 119.711 24.9251C114.937 27.2959 92.8922 36.5437 93.8976 45.2634C95.0466 55.1944 122.555 50.0108 122.555 50.0108L127.456 32.9847C127.456 32.9847 109.318 39.988 108.789 38.7251L122.578 27.514",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.555 22.5648C123.876 22.724 124.155 22.9559 124.371 23.2422C124.576 23.5274 124.711 23.8567 124.766 24.2036C124.821 24.5504 124.794 24.9053 124.687 25.2399C124.359 26.0016 123.803 26.6432 123.095 27.0768C122.97 27.1848 122.826 27.2685 122.67 27.3236C122.531 27.3602 122.385 27.3663 122.244 27.3416C122.102 27.3168 121.967 27.2617 121.848 27.1801C121.613 27.0241 121.405 26.8301 121.234 26.6061C120.969 26.2383 120.793 25.8143 120.719 25.3671C120.645 24.92 120.676 24.4619 120.809 24.0286C121.038 23.2537 121.682 22.3869 122.532 22.3696C122.884 22.3531 123.234 22.42 123.555 22.5648Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.17 31.493C136.32 30.477 134.556 27.8134 134.516 23.2383L130.85 23.8927C130.85 23.8927 130.276 30.7812 128.679 32.4517L128.713 32.4861L137.17 31.493Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M137.17 31.493C136.32 30.477 134.556 27.8134 134.516 23.2383L130.85 23.8927C130.85 23.8927 130.276 30.7812 128.679 32.4517L128.713 32.4861L137.17 31.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.076 18.4669C128.076 18.4669 128.202 26.7044 132.534 26.9914C136.866 27.2784 135.338 17.9732 135.338 17.9732C135.338 17.9732 134.735 13.0708 132.178 12.7494C129.621 12.4279 126.869 12.6346 128.076 18.4669Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.237 20.3661C128.237 20.3661 125.939 19.9355 126.209 21.0607C126.479 22.1858 126.255 23.7357 128.725 22.7828L128.237 20.3661Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.987 19.1489C134.987 19.1489 137.521 18.2534 137.504 19.4015C137.487 20.5496 137.596 22.0593 134.987 21.6058V19.1489Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.932 20.1193C128.007 20.1803 128.097 20.2212 128.192 20.2383C128.288 20.2553 128.386 20.248 128.478 20.2169C128.731 20.0997 128.935 19.8963 129.052 19.6429C129.693 18.5126 129.957 17.2076 129.805 15.9173C130.156 16.798 130.653 17.6132 131.276 18.3283C131.898 19.0451 132.777 19.4901 133.723 19.5683C136.539 19.6429 136.125 16.4971 135.774 14.6143C135.55 13.3801 135.16 11.9794 134.051 11.2217C133.599 10.9275 133.058 10.8016 132.523 10.8658C131.839 10.8658 131.178 10.6648 130.489 10.6993C129.698 10.719 128.935 10.9973 128.317 11.4915C127.833 11.9432 127.458 12.4986 127.22 13.116C126.434 15.0982 126.465 17.3103 127.306 19.2698C127.439 19.6016 127.654 19.894 127.932 20.1193Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.058 59.9248C145.335 65.8776 143.364 71.7616 141.727 76.3195C131.833 76.6065 117.815 79.3389 117.528 76.0841C117.367 74.3218 119.797 74.4825 119.096 72.0658C118.688 70.625 117.125 63.7536 116.436 62.1348C112.702 53.306 114.77 43.8688 119.027 38.203C126.1 28.7829 139.354 28.0022 148.328 33.0366C152.723 35.4705 150.494 47.8641 147.058 59.9248Z",
    fill: "#0D9F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.357 30.9809C128.926 31.2679 123.508 43.7763 126.685 59.9816C126.685 59.9816 131.333 37.8292 136.016 29.7754C136.021 29.7754 131.695 29.8558 129.357 30.9809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M148.477 63.2761L145.266 76.0141L141.727 76.3183L117.539 78.3849C117.378 76.6283 119.797 74.4814 119.096 72.0417C127.812 70.5607 138.285 68.2703 134.39 56.7894C130.104 44.1604 136.688 35.4062 136.688 35.4062L147.07 59.9237L148.477 63.2761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.309 36.9152C136.427 35.9849 136.739 35.0898 137.227 34.2887C137.715 33.4875 138.367 32.7985 139.14 32.2668C139.913 31.735 140.79 31.3726 141.713 31.2032C142.636 31.0338 143.585 31.0613 144.496 31.2839C149.621 32.5583 156.056 36.5823 157.015 48.6544C158.653 69.1421 152.844 78.8147 152.844 78.8147H120.751V74.7447L143.048 72.0238C143.048 72.0238 134.545 51.008 136.309 36.9152Z",
    fill: "#0D9F3F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M136.309 36.9152C136.427 35.9849 136.739 35.0898 137.227 34.2887C137.715 33.4875 138.367 32.7985 139.14 32.2668C139.913 31.735 140.79 31.3726 141.713 31.2032C142.636 31.0338 143.585 31.0613 144.496 31.2839C149.621 32.5583 156.056 36.5823 157.015 48.6544C158.653 69.1421 152.844 78.8147 152.844 78.8147H120.751V74.7447L143.048 72.0238C143.048 72.0238 134.545 51.008 136.309 36.9152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.829 30.9015C127.829 30.9015 125.255 31.3722 124.318 29.983C123.382 28.5938 122.279 21.3264 122.169 20.5974C122.06 19.8683 124.008 17.4574 124.669 17.9223C125.329 18.3873 126.599 20.959 126.082 21.4642C125.533 21.9191 124.943 22.3208 124.318 22.6639C124.318 22.6639 124.709 26.9578 125.565 27.5778C126.421 28.1977 127.823 27.153 128.294 27.9509C128.765 28.7488 129.127 30.7924 127.829 30.9015Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.214 29.7227C126.145 33.9304 126.863 38.0865 127.444 42.2311C127.886 45.3998 128.455 49.5674 127.064 52.5639C126.49 53.7119 125.002 54.8199 124.037 53.9588C123.307 53.2986 123.721 51.9209 124.611 51.5535C125.085 51.409 125.592 51.413 126.063 51.5649C126.535 51.7168 126.948 52.0093 127.248 52.4031C127.828 53.2059 128.203 54.138 128.34 55.1184C128.818 57.1347 128.871 59.2285 128.495 61.2664C128.102 63.3174 126.912 65.1296 125.186 66.3065C124.673 66.6668 124.06 66.8557 123.433 66.8461C123.122 66.8324 122.823 66.719 122.581 66.5226C122.339 66.3262 122.166 66.0572 122.089 65.7554C122.042 65.395 122.128 65.0298 122.33 64.7278C123.192 63.3042 125.49 63.2813 126.651 64.4695C127.811 65.6578 127.897 67.621 127.191 69.1308C126.41 70.6057 125.211 71.8177 123.744 72.6152C121.147 74.1824 116.332 76.1513 113.241 75.3993C111.857 75.0664 110.713 74.1077 109.639 73.1663C108.714 72.3569 107.8 71.5303 106.898 70.6979C105.996 69.8655 105.026 68.9758 104.026 68.1549C100.593 65.4151 96.4616 63.6892 92.0986 63.1722",
    stroke: "#24285B",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7932 68.4647H78.2637L79.746 61.1055H92.3051L93.7932 68.4647Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4518 58.9258H81.2686V61.1071H83.4518V58.9258Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7838 58.9258H88.6006V61.1071H90.7838V58.9258Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.642 75.3373C120.642 75.3373 108.577 71.8414 110.013 78.661H120.642V75.3373Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.866 1.94531H89.0479C83.6728 1.94531 79.3154 6.29903 79.3154 11.6696V11.6754C79.3154 17.0459 83.6728 21.3997 89.0479 21.3997H101.866C107.241 21.3997 111.598 17.0459 111.598 11.6754V11.6696C111.598 6.29903 107.241 1.94531 101.866 1.94531Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.354 20.4816C101.354 20.4816 104.382 24.6664 110.495 23.4322C110.495 23.4322 105.083 23.5872 103.555 18.8398L101.354 20.4816Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M89.0196 13.5809C90.0762 13.5809 90.9328 12.7251 90.9328 11.6694C90.9328 10.6137 90.0762 9.75781 89.0196 9.75781C87.963 9.75781 87.1064 10.6137 87.1064 11.6694C87.1064 12.7251 87.963 13.5809 89.0196 13.5809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M95.4542 13.5809C96.5108 13.5809 97.3674 12.7251 97.3674 11.6694C97.3674 10.6137 96.5108 9.75781 95.4542 9.75781C94.3976 9.75781 93.541 10.6137 93.541 11.6694C93.541 12.7251 94.3976 13.5809 95.4542 13.5809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M101.895 13.5809C102.951 13.5809 103.808 12.7251 103.808 11.6694C103.808 10.6137 102.951 9.75781 101.895 9.75781C100.838 9.75781 99.9814 10.6137 99.9814 11.6694C99.9814 12.7251 100.838 13.5809 101.895 13.5809Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135183_234921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 140,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customer_service.875adce4c81b2c5b94d6ff025c2fbfef.svg";
export { ForwardRef as ReactComponent };